import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../../store/hooks';
import { queryParams } from "../../../helpers/UrlHelpers";
import { fetchCsvImports } from "../../../actions/callrecorder/csvImportsActions";
import { fetchProviders } from "../../../actions/callrecorder/providersActions";
import callrecorderUrls from "src/configs/callrecorder/callrecorderUrls";

import PageLayout from '../_partials/PageLayout';
import ListTable from "./_partials/_ListTable";
import InlineUploadForm from "./_partials/_InlineUploadForm";
import PageHeader from "src/componets/PageHeader";
import Wrapper from "../../../componets/Wrapper";
import Filter from "../../../componets/Filter";
import Can from "../../../componets/Can";
import './style.scss';

const LIMIT = 42;

const NAV_ITEMS: {[index: number]: any} = {
  0: {
    id: 0,
    name: 'Rates',
    url: callrecorderUrls.csvImportsPath({ import_type: 'rate' })
  },
  1: {
    id: 1,
    name: 'Phone Number Price',
    url: callrecorderUrls.csvImportsPath({ import_type: 'phone_number_price' })
  }
};

const CsvImports = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const currentPage = queryParams.getInt(searchParams, 'page') || 1;
  const import_type = queryParams.get(searchParams, 'import_type') || 'rate';
  const activeId = Object.values(NAV_ITEMS).find(e => e.url === callrecorderUrls.csvImportsPath({ import_type }))?.id || 0;

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        limit:  LIMIT,
        offset: (currentPage - 1) * LIMIT,
        import_type: import_type
      },
      ['term', 'search_by', 'order_by', 'order', 'date_from', 'date_to']
    );

    dispatch(fetchCsvImports(params));
    dispatch(fetchProviders({}));
  }, [searchParams, import_type, currentPage, dispatch]);

  return (
    <PageLayout className='v-up-phone-number-prices'>
      <PageHeader
        title='Imports'
        navs={NAV_ITEMS}
        activeId={activeId}
      />

      <div className='v-container'>
        <Can capability='write_callrecorder'>
          <Wrapper type='type-1' border className='v-mb-10'>
            <InlineUploadForm importType={import_type} />
          </Wrapper>
        </Can>

        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter dateRange />
        </Wrapper>

        <ListTable limit={LIMIT} />
      </div>
    </PageLayout>
  );
}

export default CsvImports;
